
export default function CTASection() {
  return (
    <section className="py-16 bg-blue-600">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <h2 className="text-2xl md:text-3xl font-bold text-white mb-4">
          Klaar om uw project te starten?
        </h2>
        <p className="text-blue-100 mb-8 max-w-2xl mx-auto">
          Neem vandaag nog contact met ons op voor een vrijblijvende offerte.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <a 
            href="#contact-form" 
            className="bg-white text-blue-600 px-8 py-3 rounded-lg font-semibold hover:bg-gray-100 transition-colors whitespace-nowrap cursor-pointer"
          >
            Offerte Aanvragen
          </a>
          <a 
            href="tel:+32483599049" 
            className="bg-transparent border-2 border-white text-white px-8 py-3 rounded-lg font-semibold hover:bg-white/10 transition-colors whitespace-nowrap cursor-pointer"
          >
            <i className="ri-phone-line mr-2"></i>
            Bel Ons
          </a>
        </div>
      </div>
    </section>
  );
}
